import getBoxSizeString from 'components/helpers/getBoxSizeString';

const qtyMap = {
  1: {
    name: 'Occasional',
    id: 'occasional',
  },
  2: {
    name: 'Part Time',
    id: 'partTime',
  },
  3: {
    name: 'Full Time',
    id: 'fullTime',
  },

};

const getLens = (productOptions) => ({
  count: [productOptions.left_eye, productOptions.right_eye]
    .filter((o) => !!o)
    .length,
  hasLeft: !!productOptions.left_eye,
  hasRight: !!productOptions.right_eye,
  lens: productOptions.left_eye || productOptions.right_eye || null,
});

const getPriceForOption = (productOptions, quantity) => {
  const rightPriceOption = productOptions.right_eye
   && productOptions.right_eye.price_options.find((o) => o.quantity === quantity);
  const leftPriceOption = productOptions.left_eye
   && productOptions.left_eye.price_options.find((o) => o.quantity === quantity);

  return ((rightPriceOption && rightPriceOption.gross_amount * quantity) || 0)
    + ((leftPriceOption && leftPriceOption.gross_amount * quantity) || 0);
};

// eslint-disable-next-line import/prefer-default-export
export const mapProductOptions = (productOptions, currentQuantity) => {
  const { count, lens } = getLens(productOptions);

  const mappedOptions = lens.price_options.map((opt) => {
    const qMap = lens.box_size === 3 ? { name: 'Monthly', id: 'monthly' } : qtyMap[opt.quantity];
    const boxSize = lens.box_size;
    const equivalent = Math.round((boxSize * opt.quantity) / 3);
    return {
      title: qMap.name,
      id: qMap.id,
      subTitle: getBoxSizeString({ boxSize, quantity: opt.quantity, numberOfEyes: count }),
      description: `Equivalent to ${equivalent} ${count === 2 ? `pair${equivalent > 1 ? 's' : ''}` : `lens${equivalent > 1 ? 'es' : ''}`} a month`,
      price: {
        currency: lens.currency,
        price: (getPriceForOption(productOptions, opt.quantity)) / lens.payments_for_delivery,
        frequency: 'mo.',
      },
      quantity: opt.quantity,
      selected: opt.quantity === currentQuantity,
    };
  });

  const { solution } = productOptions;
  const mappedSolution = solution ? {
    name: solution.product_description,
    price: solution.price_options[0].gross_amount / lens.payments_for_delivery,
    currency: solution.currency,
  } : null;

  return { plans: mappedOptions, solution: mappedSolution };
};

export const mapTopupOptions = (productOptions, toppedUpAmountWithinThreeMonths, solutionSku) => {
  const {
    count, lens, hasLeft, hasRight,
  } = getLens(productOptions);

  const options = lens.price_options
    .filter((po) => po.quantity < 3)
    .filter((opt) => lens.box_size * opt.quantity + toppedUpAmountWithinThreeMonths <= 60)
    .map((opt) => {
      const qMap = lens.box_size === 3 ? { name: 'Monthly', id: 'monthly' } : qtyMap[opt.quantity];
      const boxSize = lens.box_size;
      const numOfBoxes = opt.quantity * count;
      const equivalent = Math.round((boxSize * opt.quantity) / 3);
      return {
        title: `${opt.quantity * boxSize} ${count > 1 ? 'pairs' : 'lenses'}`,
        numberOfEyes: count,
        hasLeft,
        hasRight,
        boxSize,
        id: qMap.id,
        lensmail: lens.lensmail,
        subTitle: `${numOfBoxes} box${numOfBoxes > 1 ? 'es' : ''}`,
        description: `Equivalent to ${equivalent} ${count === 2 ? `pair${equivalent > 1 ? 's' : ''}` : `lens${equivalent > 1 ? 'es' : ''}`} a month`,
        price: {
          currency: lens.currency,
          price: getPriceForOption(productOptions, opt.quantity),
        },
        quantity: opt.quantity,
      };
    });

  const solution = productOptions.solution ? {
    name: productOptions.solution.product_description,
    price: productOptions.solution.price_options[0].gross_amount,
    currency: productOptions.solution.currency,
    sku: solutionSku,
  } : null;

  return { options, solution };
};
